import { Content } from "components/Layout";
import React from "react";
import Piepagina from "./FooterHomePublica";
const HomePublica = ({ children }) =>
  <main className="cr-app ">
    <Content fluid>
      {children}
      <p/>
      <Piepagina />
    </Content>
  </main>

export default HomePublica;
